import { cva } from 'class-variance-authority';
const root = cva([
    'bg-keyboard-shortcuts text-tooltip-primary inline-flex items-center justify-center shrink-0',
    'h-tooltip-keyboard-shortcut w-tooltip-keyboard-shortcut px-25 min-w-fit rounded-keyboard-shortcut keyboard-shortcut leading-none',
]);
export const styles = {
    root,
};
